import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ThemeContext from "../../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import "./navbar.css";
import { Alert, GetSessionUrls, Log, RemoveSessionUrl, SetLocalSetting, TrackSessionUrl, TruncateText } from "../../utils/genericUtils";
import { ProfilePictureModal } from "../Modals/EditProfilePictureModal/edit-profile-picture-modal";
import defaultProfilePicture from "../../assets/images/defaultProfilePicture.png";
import { GetFile } from "../../utils/httpUtils";
import { AlertContext } from "../../context/AlertContext";

function Navbar(props) {
  const { user, loginUser } = useContext(UserContext);
  const [navOpen, setNavOpen] = useState(false);
  const { setTheme } = useContext(ThemeContext);

  const [profilePicture, setProfilePicture] = useState(defaultProfilePicture);
  const [retryProfilePicture, setRetryProfilePicture] = useState(false);
  const [showProfilePictureModal, setShowProfilePictureModal] = useState(false);
  const { globalAlert } = useContext(AlertContext);

  const [forceUpdate, setForceUpdate] = useState(false);

  const router = useNavigate();

  //once per load
  useEffect(() => {
    Log("navbar user: ", user);
    if (navOpen) {
      document.querySelector("#nav-shelf").style.maxHeight = "70vh";
      document.querySelector("#nav-shelf").style.paddingTop = "20px";
      document.querySelector("#nav-shelf").style.paddingBottom = "20px";
    } else {
      document.querySelector("#nav-shelf").style.maxHeight = "0px";
      document.querySelector("#nav-shelf").style.paddingTop = "0px";
      document.querySelector("#nav-shelf").style.paddingBottom = "0px";
    }
  }, [navOpen, user]);

  useEffect(() => {
    let profile_picutre_session_url = GetSessionUrls().find((x) => x.objectId === "__profile_picture");

    if (profile_picutre_session_url) {
      setProfilePicture(profile_picutre_session_url.url);
    } else {
      if (user && user.profilePictureUrl && user.profilePictureUrl.toLowerCase() !== "null ") {
        GetFile(user.profilePictureUrl, user).then((file) => {
          if (file && file.url) {
            TrackSessionUrl("__profile_picture", file.url);
            setProfilePicture(file.url);
          }
        });
      }
    }
  }, [retryProfilePicture, forceUpdate]);

  function toggleNav() {
    let toggle = document.querySelector("#nav-toggle");
    toggle.classList.toggle("open");
    setNavOpen(!navOpen);
  }

  function logout() {
    toggleNav();
    sessionStorage.clear();

    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("object-tokens");
    sessionStorage.removeItem("object_urls");

    localStorage.removeItem("jwt");

    SetLocalSetting("theme", undefined);
    setTheme("light");
    loginUser(null);
    router("/");
  }

  return (
    <nav id="nav" className="navbar">
      <section className="nav-container">
        <section className="nav-left">
          <div className="logo-container"></div>
        </section>

        <section className="links-section">
          <a
            onClick={() => {
              router("/");
            }}
            className={`nav-link ${props.active === "Home" ? "active" : ""}`}
          >
            Home
          </a>

          {user ? (
            <>
              <a
                onClick={() => {
                  router("/dashboard");
                }}
                className={`nav-link ${props.active === "Dashboard" ? "active" : ""}`}
              >
                Dashboard
              </a>
              <a onClick={logout} className={"nav-link"}>
                Sign Out
              </a>
            </>
          ) : (
            <>
              <a
                onClick={() => {
                  router("/login");
                }}
                className={`nav-link ${props.active === "Login" ? "active" : ""}`}
              >
                Login
              </a>
              <span className="login-sign-up-seperator">/</span>
              <a
                onClick={() => {
                  router("/register");
                }}
                className={`nav-link ${props.active === "Sign Up" ? "active" : ""}`}
              >
                Sign Up
              </a>
            </>
          )}
        </section>

        <section className="responsive-links">
          <button id="nav-toggle" className="nav-toggle" onClick={toggleNav}>
            <div className="nav-toggle-brgr"></div>
          </button>
        </section>
      </section>

      {/* MOBILE */}
      <section id="nav-shelf" className="nav-shelf">
        {user && (
          <section className="profile-section">
            {/* PROFILE PICTURE COMPONENT */}
            <ProfilePictureModal
              id="side-nav-profile-picture-modal-mobile"
              isActive={showProfilePictureModal}
              onCloseModal={() => setShowProfilePictureModal(false)}
              onClickOut={() => setShowProfilePictureModal(false)}
              forceUpdate={() => setForceUpdate(true)}
            />
            <div className="profile-picture-container" onClick={() => setShowProfilePictureModal(true)}>
              <img
                className="profile-picture"
                src={profilePicture}
                alt="user profile picture"
                onError={(e) => {
                  if (profilePicture.includes("blob:")) {
                    //untrack non working profile picture
                    RemoveSessionUrl("__profile_picture");
                    setRetryProfilePicture(true);
                  }

                  e.target.src = defaultProfilePicture;
                  SetLocalSetting("__profile_picture", null);
                }}
              />
            </div>

            <div className="welcome-back-container-navbar">
              <h5 className="welcome-back-text">Welcome Back</h5>
              <p className="user-full-name-text">
                {user && user.firstName && user.lastName && TruncateText(user.firstName + " " + user.lastName, 17)}
              </p>
            </div>
          </section>
        )}

        <a
          onClick={() => {
            toggleNav();
            router("/");
          }}
          className={`nav-link ${props.active === "Home" ? "active" : ""}`}
        >
          Home
        </a>
        {user ? (
          <>
            <a
              onClick={() => {
                toggleNav();

                router("/dashboard");
              }}
              className={`nav-link ${props.active === "Dashboard" ? "" : ""}`}
            >
              Dashboard
            </a>
            <a
              onClick={() => {
                toggleNav();

                router("/settings");
              }}
              className={`nav-link ${props.active === "Settings" ? "" : ""}`}
            >
              Settings
            </a>
            <a
              onClick={() => {
                toggleNav();

                router("/dashboard/trash");
              }}
              className={`nav-link ${props.active === "" ? "" : ""}`}
            >
              Trash
            </a>
            <a onClick={logout} className={"nav-link"}>
              Sign Out
            </a>
          </>
        ) : (
          <>
            <a
              onClick={() => {
                router("/login");
              }}
              className={`nav-link ${props.active === "Login" ? "active" : ""}`}
            >
              Login
            </a>
            <a
              onClick={() => {
                router("/register");
              }}
              className={`nav-link ${props.active === "Sign Up" ? "active" : ""}`}
            >
              Sign Up
            </a>
          </>
        )}
      </section>
    </nav>
  );
}

export default Navbar;
